/**
 * Formats a slider value for display, appending the unit in brackets when present.
 * Shared by NumberSliderRangeFilter and SliderFilter (FileSizeSliderFilter has its own
 * unit-factor-aware variant). Module-level so it never lands in a component closure.
 */
export const formatSliderValue = (value: number, unit: string | null): string =>
  unit ? `${value} [${unit}]` : `${value}`;
